/**
 * 函数描述：js调用webview事件
 *
 * jsBridge.callHandler(method, data, callBack(response));
 * @param method {string} 方法名
 * @param data {Object} 参数
 * @return {Object} 回调
 */

/**
 * 函数描述：webView调用JS事件
 *
 * jsBridge.registerHandler(method, callBack(response));
 * @param method {string} 方法名
 * @return {Object} 回调
 */
// import Vue from 'vue'
// import { Toast } from 'vant'
// Vue.use(Toast)
import { getBrowser } from "@/utils/browser";

/** 等待 WebView Bridge 可用（App 内 loadAppConfig 等需先就绪） */
export function waitForJsBridge(maxWaitMs = 8000): Promise<boolean> {
  const browser = getBrowser();
  if (!browser.isApp) return Promise.resolve(false);

  const hasBridge = () => !!(window as any).WebViewJavascriptBridge;

  return new Promise(resolve => {
    if (hasBridge()) {
      resolve(true);
      return;
    }

    let settled = false;
    const done = (ok: boolean) => {
      if (settled) return;
      settled = true;
      clearInterval(poll);
      clearTimeout(hardTimeout);
      document.removeEventListener("WebViewJavascriptBridgeReady", onReady);
      resolve(ok);
    };

    const onReady = () => done(hasBridge());
    document.addEventListener("WebViewJavascriptBridgeReady", onReady);

    const poll = setInterval(() => {
      if (hasBridge()) done(true);
    }, 50);

    const hardTimeout = setTimeout(() => done(hasBridge()), maxWaitMs);
  });
}

const JsBridge = {
  init(callback) {
    const browser = getBrowser();
    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (browser.isApp) {
      if (!isiOS) {
        
        if ((window as any).WebViewJavascriptBridge) {
          callback((window as any).WebViewJavascriptBridge);
        } else {
          document.addEventListener(
            "WebViewJavascriptBridgeReady",
            function() {
              callback((window as any).WebViewJavascriptBridge);
            },
            false
          );
        }
      } else {
        
        if ((window as any).WebViewJavascriptBridge) {
          return callback((window as any).WebViewJavascriptBridge);
        }
        if ((window as any).WVJBCallbacks) {
          return (window as any).WVJBCallbacks.push(callback);
        }
        (window as any).WVJBCallbacks = [callback];
        const WVJBIframe = document.createElement("iframe");
        WVJBIframe.style.display = "none";
        WVJBIframe.src = "wvjbscheme://__BRIDGE_LOADED__";
        document.documentElement.appendChild(WVJBIframe);
        setTimeout(function() {
          document.documentElement.removeChild(WVJBIframe);
        }, 0);
      }
    }
  },

  first() {
    const browser = getBrowser();
    if (!browser.isApp) return;

    // iOS：尽早触发 WVJB 加载
    if (browser.isIos) {
      this.init(() => {});
      return;
    }

    // 安卓：微信内不建立 bridge
    if (!browser.isWechat) {
      this.init(function(bridge) {
        bridge.init(function(message, responseCallback) {
          responseCallback();
        });
      });
    }
  },

  themeDidChange(name, fun) {
    this.init(function(bridge) {
      bridge.registerHandler(name, fun);
    });
  },

  registerHandler(name, fun) {
    this.init(function(bridge) {
      bridge.registerHandler(name, fun);
    });
  },

  callHandler(name, data, fun?: Function) {
    this.init(function(bridge) {
      bridge.callHandler(name, data, fun);
    });
  }
};

JsBridge.first();

export default JsBridge;
